import { useAuthLogic } from '../../../container/screen/Auth/logic/useAuth.logic';
import { useAccountSwitcher } from '../../../container/screen/Users/subcomponents/AccountSwitcher/logic/useAccountSwitcher';
import { useAppSelector } from '../../../hooks/ReduxHook';
import useNavigation from '../../../hooks/useNavigation';

export const useHeader = () => {
  const { doSignOut, user } = useAuthLogic();
  const { doToggleAccountSwitcher } = useAccountSwitcher();
  const { gotoPage } = useNavigation();
  const { base } = useAppSelector((state) => state);

  const doGoLandingUrl = () => {
    if (base.landUrl) {
      window.location.href = base.landUrl;
      return;
    }
  };

  return {
    base,
    doSignOut,
    doToggleAccountSwitcher,
    gotoPage,
    user,
    doGoLandingUrl,
  };
};
